"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.separateColumnProcessor = void 0;
const react_1 = __importDefault(require("react"));
const GridExpandableCell_1 = require("../../../renderers/gridExpandableCell/GridExpandableCell");
const separateColumnProcessor = (columns, config) => {
    const groupColumnConfig = config === null || config === void 0 ? void 0 : config.groupColumnConfig;
    if (!groupColumnConfig) {
        return [...columns];
    }
    return [
        Object.assign(Object.assign({}, groupColumnConfig), { isService: true, cell: (props) => {
                const rowIndex = props.rowIndex;
                const meta = config.getMetaByIndex(rowIndex);
                return (react_1.default.createElement(GridExpandableCell_1.GridExpandableCell, { isExpandable: meta.isExpandable, depth: meta.depth, isExpanded: meta.isExpanded, onClick: () => config.onClick(rowIndex, meta) }, config.cellRenderer(props, meta)));
            } }),
        ...columns
    ];
};
exports.separateColumnProcessor = separateColumnProcessor;
//# sourceMappingURL=separateColumnProcessor.js.map